import React from 'react';
import ProfileDropdown from './ProfileDropdown';

const DropdownSituationCivile = (props) => {

    const {
        dropdownProps = {},
        id = undefined
    } = props;

    return <ProfileDropdown
        {...dropdownProps}
        id={id}
        label="Situation civile"
        options={[
            { key: "Célibataire", text: "Célibataire" },
            { key: "Marié", text: "Marié" },
            { key: "Pacsé", text: "Pacsé" },
            { key: "Divorcé", text: "Divorcé" },
            { key: "Veuf", text: "Veuf" }
        ]}
    />;

};

export default DropdownSituationCivile;